import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = {
  key: 1,
  class: "text-muted"
}
const _hoisted_2 = { class: "text-muted" }
const _hoisted_3 = { class: "text-muted" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" Решить ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_new_tab_link = _resolveComponent("new-tab-link")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_payment_list_layout = _resolveComponent("payment-list-layout")!
  const _component_payment_form_dialog = _resolveComponent("payment-form-dialog")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_payment_list_layout, {
      page: _ctx.page,
      pages: _ctx.pages,
      "per-page": _ctx.perPage,
      total: _ctx.total,
      onApply: _ctx.apply,
      onReset: _ctx.reset,
      onPageChange: _ctx.setPage
    }, {
      filter: _withCtx(() => [
        _createVNode(_component_el_select, {
          modelValue: _ctx.filters.status,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.filters.status) = $event)),
          placeholder: "Статус"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_option, {
              label: "Открытые",
              value: "open"
            }),
            _createVNode(_component_el_option, {
              label: "Решённые",
              value: "resolved"
            })
          ]),
          _: 1
        }, 8, ["modelValue"]),
        _createVNode(_component_el_select, {
          modelValue: _ctx.filters.reason,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.filters.reason) = $event)),
          clearable: "",
          placeholder: "Причина"
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.reasonOptions, (o) => {
              return (_openBlock(), _createBlock(_component_el_option, {
                key: o.value,
                label: o.label,
                value: o.value
              }, null, 8, ["label", "value"]))
            }), 128))
          ]),
          _: 1
        }, 8, ["modelValue"])
      ]),
      default: _withCtx(() => [
        _withDirectives((_openBlock(), _createBlock(_component_el_table, {
          border: "",
          data: _ctx.items,
          "table-layout": "fixed"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_table_column, {
              label: "Причина",
              "min-width": "200"
            }, {
              default: _withCtx(({ row }) => [
                _createTextVNode(_toDisplayString(_ctx.reasonLabels[row.reason] || row.reason), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              label: "Заказ",
              width: "160"
            }, {
              default: _withCtx(({ row }) => [
                (row.order)
                  ? (_openBlock(), _createBlock(_component_new_tab_link, {
                      key: 0,
                      to: { name: 'payments-orders-view', params: { id: row.order.id } }
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(" № " + _toDisplayString(row.order.number), 1)
                      ]),
                      _: 2
                    }, 1032, ["to"]))
                  : _createCommentVNode("", true),
                (row.order)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(_ctx.money(row.order.amount)), 1))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              label: "Платёж",
              "min-width": "260"
            }, {
              default: _withCtx(({ row }) => [
                (row.payment)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createTextVNode(_toDisplayString(_ctx.money(row.payment.amount)) + " · " + _toDisplayString(row.payment.gateway_transaction_id) + " ", 1),
                      _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.dateTime(row.payment.paid_at)), 1)
                    ], 64))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              label: "Создан",
              width: "150"
            }, {
              default: _withCtx(({ row }) => [
                _createTextVNode(_toDisplayString(_ctx.dateTime(row.created_at)), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              label: "Решение",
              "min-width": "220"
            }, {
              default: _withCtx(({ row }) => [
                (row.status === 'resolved')
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createTextVNode(_toDisplayString(_ctx.resolutionLabels[row.resolution]) + " ", 1),
                      _createElementVNode("div", _hoisted_3, _toDisplayString(row.note), 1)
                    ], 64))
                  : (_openBlock(), _createBlock(_component_el_button, {
                      key: 1,
                      size: "small",
                      type: "primary",
                      onClick: ($event: any) => (_ctx.openResolve(row))
                    }, {
                      default: _withCtx(() => [
                        _hoisted_4
                      ]),
                      _: 2
                    }, 1032, ["onClick"]))
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["data"])), [
          [_directive_loading, _ctx.loading]
        ])
      ]),
      _: 1
    }, 8, ["page", "pages", "per-page", "total", "onApply", "onReset", "onPageChange"]),
    _createVNode(_component_payment_form_dialog, {
      modelValue: _ctx.resolveOpen,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.resolveOpen) = $event)),
      title: "Решение по инциденту",
      fields: _ctx.resolveFields,
      action: _ctx.resolveAction,
      onDone: _ctx.onResolved
    }, null, 8, ["modelValue", "fields", "action", "onDone"])
  ], 64))
}